/**
 * Хелпер для удаления опасных схем из URL и санитизации параметров запроса.
 * @param {string} url - URL, который нужно обработать.
 * @returns {string} - Очищенный URL.
 */
export function sanitizeUrl(url) {
  if (!url) {
    return '';
  }

  // Запрещенные схемы
  const dangerousSchemes = ['javascript:', 'data:', 'vbscript:', 'about:', 'file:'];
  const isDangerous = dangerousSchemes.some(scheme => url.startsWith(scheme));

  if (isDangerous) {
    console.error('Dangerous URL detected:', url);
    return '';
  }

  try {
    // Парсим URL
    const parsedUrl = new URL(url);

    // Санитизация параметров запроса
    const params = parsedUrl.searchParams;
    params.forEach((value, key) => {
      // Удаляем опасные символы из параметров
      const sanitizedValue = value.replace(/[<>"']/g, '');
      params.set(key, sanitizedValue);
    });

    // Возвращаем безопасный URL
    return parsedUrl.toString();
  } catch (error) {
    console.error('Invalid URL:', url);
    return '';
  }
}
